import { OLAF, KOALA, BATTLESHIP, LORAX } from 'HubStyleTokens/colors';
import UIIconCircle from 'UIComponents/icon/UIIconCircle';
import { useAllProgress } from '../../../features/userProgress';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentStepIconIndicator = ({
  contentId,
  isActive,
  circleSize,
  shortId,
  language
}) => {
  const {
    allProgress,
    allProgressLoading
  } = useAllProgress();
  let hasCompleted = false;
  if (contentId) {
    var _allProgress$contentP;
    hasCompleted = (_allProgress$contentP = allProgress.contentProgress[contentId]) === null || _allProgress$contentP === void 0 ? void 0 : _allProgress$contentP.completed;
  } else if (shortId && language) {
    hasCompleted = allProgress.assetProgress.some(({
      id,
      type,
      language: itemLanguage
    }) => id === shortId && itemLanguage === language && type === 'SHORT_FORM_CONTENT');
  }
  // start with defaults, then override as neccessary
  let backgroundColor = KOALA;
  const borderColor = isActive || hasCompleted ? LORAX : BATTLESHIP;
  let color = KOALA;
  const name = hasCompleted ? 'success' : 'blank';
  if (isActive) {
    backgroundColor = OLAF;
    color = hasCompleted ? LORAX : OLAF;
  } else if (hasCompleted) {
    backgroundColor = LORAX;
    color = OLAF;
  }
  return /*#__PURE__*/_jsx(UIIconCircle, {
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderWidth: 2,
    color: color,
    "data-test-id": "content-step-indicator-icon",
    "data-test-progress-is-requesting": allProgressLoading,
    name: name,
    size: circleSize / 2
  });
};
export default ContentStepIconIndicator;